module.exports = __webpack_public_path__ + "static/media/tooltip.490ba9e2.png";